module.exports = __webpack_public_path__ + "img/bg_07.cfb5e69d.png";